import './feed-header.scss';
import { useTranslation } from 'react-i18next';
import { Button, IconButton } from '@socialchorus/shared-ui-components';
import { useLinkNavigation } from '../../../common/use-link-navigation';
import {
  trackChannelViewClick,
  trackFeedViewAllClick,
} from '../../../models/analytics';

export type FeedHeaderProps = {
  id: string;
  title?: string;
  viewAllLink?: string;
  viewAllText?: string;
  description?: string;
  isTopic: boolean;
  analyticsData: IAnalyticsData;
  isMobileHorizontal?: boolean;
};

export default function FeedHeader({
  id,
  title,
  viewAllLink,
  viewAllText,
  description,
  analyticsData,
  isTopic,
  isMobileHorizontal,
}: FeedHeaderProps) {
  const { t } = useTranslation();
  const linkNavigation = useLinkNavigation();
  const handleClick = () => {
    if (isTopic) {
      trackChannelViewClick(analyticsData);
    } else {
      trackFeedViewAllClick(analyticsData);
    }
  };

  const resolvedViewAllText = viewAllText || t('landing.see_all');

  return (
    <header className="feed-header">
      <div className="feed-header__first-row">
        <h2 id={`${id}--title`} className="feed-header__title">
          {title}
        </h2>
        {viewAllLink &&
          (isMobileHorizontal ? (
            <IconButton
              iconName="chevron_right"
              size="compact"
              className="feed-header__view-all-btn"
              href={linkNavigation(viewAllLink)}
              onClick={handleClick}
              label={resolvedViewAllText}
            />
          ) : (
            <Button
              variant="outline"
              size="compact"
              className="feed-header__view-all-btn"
              href={linkNavigation(viewAllLink)}
              onClick={handleClick}
              label={resolvedViewAllText}
            />
          ))}
      </div>
      {description && (
        <h3 id={`${id}--description`} className="feed-header__description">
          {description}
        </h3>
      )}
    </header>
  );
}

type FeedViewAllFooterProps = {
  viewAllLink: string;
  viewAllText?: string;
  isTopic: boolean;
  analyticsData: IAnalyticsData;
};

export function FeedViewAllFooter({
  viewAllLink,
  viewAllText,
  isTopic,
  analyticsData,
}: FeedViewAllFooterProps) {
  const { t } = useTranslation();
  const linkNavigation = useLinkNavigation();
  const handleClick = () => {
    if (isTopic) {
      trackChannelViewClick(analyticsData);
    } else {
      trackFeedViewAllClick(analyticsData);
    }
  };

  return (
    <div className="feed-header__view-all-footer">
      <Button
        variant="outline"
        className="feed-header__view-all-btn"
        href={linkNavigation(viewAllLink)}
        onClick={handleClick}
        label={viewAllText || t('landing.see_all')}
      />
    </div>
  );
}
